module.exports = __webpack_public_path__ + "img/header_dsk.9cb6f1e.webp";